import React from 'react';
import Link from 'next/link';
export default function DropDownMenu({ item, last }) {
  return (
    <li className={`${last ? 'hasBefore' : ''} dropdown relative py-2 group `}>
      <Link
        target="_blank"
        href={`${
          item.type == 'product_category'
            ? '/cat'
            : item.type == 'brand'
            ? '/brand'
            : item.type == 'page'
            ? '/page'
            : ''
        }${item.url}`}
        className={`flex ${item.class} px-4 group-hover:text-color-primary`}
      >
        {item.icon && (
          <span
            className="icon pl-2"
            dangerouslySetInnerHTML={{
              __html: item.icon.replace(
                /stroke="[^"]*"/g,
                'stroke="currentColor"'
              ),
            }}
          />
        )}
        {item.title}
        {item.children.length > 0 && (
          <>
            <b className="caret"></b>
          </>
        )}
      </Link>
      {item.children.length > 0 && (
        <ul className="dropdown-menu shadow-md rounded-md absolute top-10 hidden bg-white shadow-xy p-2 min-w-300 z-10">
          {item.children.map((childItem, index) => (
            <li className="p-2 hover:bg-primary-50 rounded-md " key={index}>
              <Link
                target="_blank"
                className="leading-8 flex items-center gap-2"
                href={`${
                  childItem.type == 'product_category'
                    ? '/cat/'
                    : childItem.type == 'brand'
                    ? '/brand/'
                    : childItem.type == 'page'
                    ? '/page/'
                    : ''
                }${childItem.url}`}
              >
                {childItem.icon && (
                  <span
                    className="icon  "
                    dangerouslySetInnerHTML={{
                      __html: childItem.icon,
                    }}
                  />
                )}
                {childItem.title}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
}
